var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"container"},[(_vm.isTemplatedProduct)?_c('templated-controller',{on:{"option-changed":_vm.handleOptionChanged}},[_vm._t("default")],2):_c('variable-controller',{on:{"option-changed":_vm.handleVariantChanged}},[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }